import { SearchableSelectType } from '../components/inputs/searchableSelect';

import { BasePaginatedResponse } from './pagination';

export enum FieldType {
    STR = 'str',
    BOOL = 'bool',
    INT = 'int',
    FLOAT = 'float',
}

export enum ValidInputType {
    TEXT = 'text',
    DROPDOWN = 'dropdown',
}

export interface AttributeValueModel {
    id: number;
    value: string;
    user_count: number;
    user_percentage: number;
}

export enum AttributeStatus {
    IN_USE = 'In use',
    AVAILABLE = 'Available',
    INACTIVE = 'Inactive',
}

export interface ContactAttributeModel {
    id: number;
    attribute_name: string;
    attribute_type: FieldType;
    sample_value: string;
    value_count: number;
    status: AttributeStatus;
}

export interface PaginatedContactAttributeModal
    extends BasePaginatedResponse<ContactAttributeModel> {}

export interface PaginatedContactAttributeValueModal
    extends BasePaginatedResponse<AttributeValueModel> {}

export interface ValidAttributeType {
    attribute_type: FieldType;
}

export interface AttributeOperatorModel {
    id: number;
    display_name: string;
    operator_key: string;
    valid_attribute_types: ValidAttributeType[];
    input_type: ValidInputType;
    created_at: string;
    updated_at: string;
}

interface AttchedContactAttributeModel extends ContactAttributeModel {
    values: AttributeValueModel[];
}
export interface AttributeModel {
    id: number | string;
    attribute: AttchedContactAttributeModel;
    operator: AttributeOperatorModel;
    value: string;
    created_at: string;
    updated_at: string;
}

export enum AUDIENCE_FILTER_TYPE {
    GENERAL = 'All',
    SPECIFIC = 'Specific',
}

export interface AudienceSearchableSelectType extends SearchableSelectType {
    attribute_type?: FieldType;
}

export interface CreateFilterAttributeModel {
    attribute: AudienceSearchableSelectType;
    operator: SearchableSelectType;
    value: SearchableSelectType | string | number;
    isRecentlyAdded?: boolean;
}

export enum AttributesTab {
    INACTIVE = 'inactive',
    ACTIVE = 'active',
}

export interface AttributeQueryParams {
    is_active: boolean;
    page?: number;
    per_page?: number;
    attribute_name?: string;
    attribute_type?: string;
    status?: string;
    sort_by_name?: boolean;
}

export interface AttributeValuesQueryParams {
    value_name?: string;
    page?: number;
    per_page?: number;
}

export interface AttributeUpdateDate {
    attribute_ids: number[];
    is_active: boolean;
}

export enum AttributeCreateType {
    CREATE = 'create',
    EXISTING = 'existing',
}

interface QueryParamAttributeType {
    attribute_type: string;
    attribute_name: string;
    id: number;
    status?: string;
}

export interface QueryParamValueType {
    id: number;
    value: string;
}
export interface QueryParamAttributeModel extends QueryParamAttributeType {
    values: QueryParamValueType[];
}
